import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1 className="privacy-policy-heading">Privacy Policy</h1>
      <div className="privacy-policy-content">
        <h2>Information We Collect:</h2>
        <p>
          This Privacy Policy describes how we collect, use, and handle your
          personal information when you use our queue management website for
          hospital services. By accessing and using our website, you agree to
          the terms and practices outlined in this Privacy Policy.
        </p>
        <h3>Personal Information:</h3>
        <p>
          When you create an account, we may collect your name, email address,
          and contact information. If you choose to provide it, we may also
          collect additional personal information such as your address or date
          of birth.
        </p>
        <h3>Usage Information:</h3>
        <p>
          We may collect information about your interactions with our website,
          including pages visited, actions taken, and time spent on each page.
        </p>
        <h2>How We Use Your Information:</h2>
        <h3> Improving Queue Management:</h3>
        <p>
          We may use your personal information to provide and improve our queue
          management services in the hospital, such as optimizing wait times and
          resource allocation.
        </p>

        <h3>Communication:</h3>
        <p>
          We may use your contact information to send you important updates,
          notifications, and reminders related to your queue status or any
          changes in our services.
        </p>
        <h3>Analytics and Research:</h3>
        <p>
          We may analyze usage patterns and anonymized data to gain insights and
          improve the efficiency of our queue management system.
        </p>
        <h3>Legal Requirements:</h3>
        <p>
          We may disclose your personal information when required by law, court
          order, or government regulation.
        </p>
        <h2>Data Security:</h2>

        <p>
          <li>
            We take reasonable measures to protect your personal information
            from unauthorized access, disclosure, alteration, or destruction.
          </li>
          <li>
            We use industry-standard security protocols and encryption methods
            to safeguard your data transmission over the internet.
          </li>
        </p>

        <h2>Data Retention:</h2>
        <p>
          <li>
       
            We retain your personal information only for as long as necessary to
            fulfill the purposes outlined in this Privacy Policy.
          </li>
          <li>
            If you wish to delete your account or request the deletion of your
            personal information, please contact us using the information
            provided below.
          </li>
        </p>

        <h2>Your Rights:</h2>
        <p>
          <li>
            You have the right to access, correct, or update your personal
            information.
          </li>
          <li>
            You have the right to request the deletion of your personal
            information, subject to legal requirements and our data retention
            policies.
          </li>
        </p>

        <h2>Updates to Privacy Policy:</h2>
        <p>
          We reserve the right to update or modify this Privacy Policy at any
          time. We will notify you of any material changes through prominent
          notices on our website or by email.
        </p>

        <h2>Contact Us:</h2>
        <p>
          If you have any questions, concerns, or requests regarding this
          Privacy Policy or the handling of your personal information, please
          contact us at "akshithkumar.karla@gmail.com "
        </p>
        <p className="privacy-policy-last-updated">
          Last updated: [22-05-2023]
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
